import { useEffect, useState } from 'react';
import { FormControl, FormLabel, Select, Text } from '@chakra-ui/react';

const TimeZoneSelect = ({
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
}) => {
  const [timeZones, setTimeZones] = useState([]);

  useEffect(() => {
    const fetchTimeZones = async () => {
      try {
        const response = await fetch(
          `http://api.timezonedb.com/v2.1/list-time-zone?key=IDU0ZFRYGTHL&format=json`,
        );
        const data = await response.json();
        if (data.status === 'OK') {
          setTimeZones(data.zones);
        } else {
          console.error('Error fetching time zones:', data.message);
        }
      } catch (error) {
        console.error('Error fetching time zones:', error);
      }
    };

    fetchTimeZones();
  }, []);

  return (
    <FormControl isInvalid={touched.timezone && errors.timezone} mb={4}>
      <FormLabel>Time Zone</FormLabel>
      <Select
        name="timezone"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.timezone}
        placeholder="Select Time Zone"
      >
        {timeZones.length > 0 ? (
          timeZones.map((tz) => (
            <option key={tz.zoneName} value={tz.zoneName}>
              {tz.zoneName} (GMT{tz.gmtOffset >= 0 ? '+' : ''}
              {tz.gmtOffset / 3600})
            </option>
          ))
        ) : (
          <option disabled>Loading time zones...</option>
        )}
      </Select>
      {touched.timezone && errors.timezone && (
        <Text color="red.500" fontSize="sm">
          {errors.timezone}
        </Text>
      )}
    </FormControl>
  );
};

export default TimeZoneSelect;
